import React from "react";

const CustomDot = ({ index, cx, cy, data, isActive }: any) => {
  const stopColors = [
    "rgba(4,11,68,1)",
    "rgba(4,11,68,1)",
    "rgba(40,124,137,1)",
    "rgba(50,157,157,1)",
    "rgba(63,202,184,1)",
    "rgba(80,254,216,1)",
  ];

  const colorIndex = Math.floor(
    (index / (data.length - 1)) * (stopColors.length - 1)
  );

  return (
    <circle
      key={index}
      cx={cx}
      cy={cy}
      r={4}
      fill={isActive ? "white" : stopColors[colorIndex]}
      stroke={stopColors[colorIndex]}
    />
  );
};

export default CustomDot;
